import $ from "jquery"
import { trace } from "./../shared/helpers.js"
import Catalogue from "./../catalogue/Catalogue";

const InfinityScroll = {
  $container: false,
  streamEnd: false,
  loader: ()=> trace("Infinity Scroll, missing loader func :("),
  // scroll events
  docEventHandler() {
    // trace("doc event handler", this.streamEnd);
    if (this.streamEnd) {
      return false;
    }
    let $container = this.$container;
    let st = $(window).scrollTop()
    let wh = $(window).height()   
    let rect = $container.get(0).getBoundingClientRect()
    let gh = rect.bottom
    let offset = 0
    if ((st + wh) > (gh - offset)) {
      this.loader()      
    }
  },
  removeDocumentEvents() {
    $(document).off('DOMContentLoaded load resize scroll touchmove', this.docEventHandler);
  },
  addDocumentEvents() {
    this.removeDocumentEvents()
    $(document).on('DOMContentLoaded load resize scroll touchmove', this.docEventHandler.bind(this));
  },

  // ############
  // ### init ###
  // ############
  // $container - marchive wrapper
  // loader - scroll callback
  init($container, loader = false) {
    // trace ("init Infinity Scroll");
    this.$container = $container;
    this.streamEnd = false;
    this.loader = loader ? loader : this.loader;
    this.addDocumentEvents();
    this.docEventHandler();
  },

}

export default InfinityScroll;